import {
    ProductsResponse,
    ProductResponse,
    ProductStatisticsResponse,
    ProductsBatchRequest,
    ProductImportResponse
} from '../types/product';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * Сервис для работы с товарами/номенклатурой
 */
export const productService = {
    /**
     * Получение списка всех активных товаров
     */
    getAllProducts: async (): Promise<ProductsResponse> => {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/products`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });

        if (!response.ok) {
            if (response.status === 403) {
                // Токен истек или нет доступа - очищаем токены
                localStorage.removeItem('accessToken');
                localStorage.removeItem('authToken');
                localStorage.removeItem('refreshToken');
            }
            throw new Error('Ошибка при получении списка товаров');
        }

        return response.json();
    },

    /**
     * Получение товара по ID
     */
    getProductById: async (id: number): Promise<ProductResponse> => {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/products/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error('Товар не найден');
            }
            throw new Error('Ошибка при получении товара');
        }

        return response.json();
    },

    /**
     * Получение товара по GUID
     */
    getProductByGuid: async (guid: string): Promise<ProductResponse> => {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/products/by-guid/${guid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error('Товар не найден');
            }
            throw new Error('Ошибка при получении товара');
        }

        return response.json();
    },

    /**
     * Получение статистики по товарам
     */
    getStatistics: async (): Promise<ProductStatisticsResponse> => {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/products/stats`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });

        if (!response.ok) {
            throw new Error('Ошибка при получении статистики');
        }

        return response.json();
    },

    /**
     * Импорт товаров из 1С (только для интеграции)
     */
    importProducts: async (data: ProductsBatchRequest): Promise<ProductImportResponse> => {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/integration/products/batch`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error('Ошибка при импорте товаров');
        }

        return response.json();
    }
};

export default productService;

